export default {
    current_user_id: ''
}